import { useThree } from "@react-three/fiber";
import gsap from "gsap";
import React from "react";

// This helper lets you programmatically control the camera with gsap
export function CameraAnimationTrigger({ triggerRef, sceneRootRef }) {
  const { camera, controls, invalidate } = useThree();

  // Expose the animate function to the parent via ref
  React.useImperativeHandle(triggerRef, () => ({
    fireCameraAnimation(camPosition, seatCode) {
      if (camPosition.indexOf(" && ") > -1) {
        const seatsCamPosition = camPosition.split(" && ");
        if (seatCode === "T19P85C" && seatsCamPosition[1]) {
          camPosition = seatsCamPosition[1];
        } else if (seatCode === "Q19P4C" && seatsCamPosition[2]) {
          camPosition = seatsCamPosition[2];
        } else if (seatsCamPosition[0]) {
          camPosition = seatsCamPosition[0];
        }
      }
      if (camPosition.indexOf("|") > -1) {
        var camPositionArr = camPosition.split("|");
        // console.log(camera.position);
        gsap.to(camera.position, {
          duration: 1.25,
          x: camPositionArr[0],
          y: camPositionArr[1],
          z: camPositionArr[2],
          // -115|-9|46
          // x: -115.25839849563104, y: -9.130862289769414, z: 46.26152753711879
          // x: -107,
          // y: -38,
          // z: 53,
          onUpdate: () => {
            invalidate();
            // camera.lookAt(0, 0, 0); // Adjust as needed
          },
        });
        if (camPositionArr[3])
          sceneRootRef.current.position.x = camPositionArr[3];
        else sceneRootRef.current.position.x = 0;
        if (camPositionArr[4])
          sceneRootRef.current.position.y = camPositionArr[4];
        else sceneRootRef.current.position.y = 0;
        invalidate();
      }
    },
    resetCamera() {
      gsap.to(camera.position, {
        duration: 1.25,
        x: -200,
        y: 60,
        z: 100,
        ease: "power2.inOut",
        onUpdate: () => {
          if (controls?.target) {
            controls.target.set(0, 0, 0);
            controls.update();
          }
          invalidate();
        },
      });

      gsap.to(camera, {
        duration: 1.25,
        fov: 24,
        near: 5,
        far: 300,
        ease: "power2.inOut",
        onUpdate: () => {
          camera.updateProjectionMatrix();
          invalidate();
        },
      });

      if (sceneRootRef.current) {
        gsap.to(sceneRootRef.current.position, {
          duration: 1.25,
          y: 0,
          x: 0,
          ease: "power2.inOut",
          onUpdate: invalidate,
        });
      }
    },
  }));

  return null;
}
